export default __webpack_public_path__ + "static/media/angularDirectory.6fc52597.JPG";